import {
  ArrowBackIos,
  ArrowBackIosNew,
  ArrowForwardIos,
  DriveFileRenameOutlineOutlined,
  Info,
  Refresh,
} from "@mui/icons-material";
import group from "../../assets/images/Group.svg";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  
  Grid2,
  
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import PopUpModal from "../../components/Modal";
import INFO_ICON from "../../assets/images/info-circle.svg";
const PatientDashboardUi = ({
  loading,
  todayDate,
  title,
  patient,
  onclickButton,
  params,
  navigate,
  handleDateNavigation,
  getDateNavigatorLabel,
  isMonthly,
  setIsMonthly,
  selectedDate,
  generateWeeklyData,
  generateMonthlyData,
  todayUsage,
  weeklyUsage,
  therapyUsage,
  CustomBarChart,
  UsageChart,
  infoIconView
}) => {
  console.log("PatientDashboardUi is rendering...");

  return (
    <>
      <PopUpModal />
      <Box sx={{ backgroundColor: "white", padding: "0px 12px" }}>
        {/* Header Section */}
        <Box
          mb={1}
          sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
          <Box
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <IconButton
              sx={{ marginRight: "10px" }}
              onClick={() => {
                navigate("/patient");
              }}
            >
              <ArrowBackIosNew sx={{ color: "#424242" }} />
              <Typography
                ml={2}
                className="AxiformaRegular"
                sx={{
                  fontSize: "24px",
                  alignItems: "center",
                  color: "#424242",
                }}
              >
                Back
              </Typography>
            </IconButton>{" "}
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            <Typography
              className="AxiformaMedium"
              variant="h6"
              ml={2}
              sx={{
                fontSize: "24px",
                alignItems: "center",
                letterSpacing: "0.8em",
                color: "#424242",
              }}
            >
              PATIENT PROFILE
            </Typography>
          </Box>
        </Box>
        {/* Profile and Actions Section */}
        <Grid2
          sx={{
            width: "100%",
            backgroundColor: "white",
            border: "1px solid #DEDEDE",
            borderRadius: "10px",
            maxHeight: "630px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "3px",
              maxHeight: "58px",
            }}
          >
            {/* User Information */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img src={group}></img>

              <Typography
                sx={{
                  fontSize: "20px",
                  color: "#424242",
                  fontWeight: "500",
                  ml: 4,
                }}
              >
                {patient?.name}
              </Typography>

              <IconButton
                onClick={(e) => {
                  infoIconView(patient);
                }}
              >
                <img src={INFO_ICON} />
              </IconButton>
            </Box>

            {/* Actions */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginRight: "20px",
              }}
            >
              <Box sx={{ marginRight: "40px" }}>
                {loading ? (
                  <CircularProgress size={24} />
                ) : patient.frequency ? (
                  <>
                    <Typography
                      sx={{
                        color: "#424242",
                        fontSize: "16px",
                        fontWeight: "500",
                        mr: 3,
                      }}
                    >
                      Tinnitus Frequency
                    </Typography>
                    <Typography
                      sx={{
                        color: "#E53935",
                        fontSize: "22px",
                        fontWeight: "700",
                        mr: 3,
                      }}
                    >
                      {patient.frequency} Hz
                      <IconButton
                        onClick={() => {
                          navigate(`/tinnitusTest/${params.id}`);
                        }}
                      >
                        <Refresh sx={{ color: "#E53935" }} />
                      </IconButton>
                    </Typography>
                  </>
                ) : (
                  <Button
                    variant="outlined"
                    sx={{
                      border: "1px solid #424242",
                      color: "#424242",
                      textTransform: "none",
                      padding: "7px 19px",
                    }}
                    onClick={() => {
                      navigate(`/tinnitusTest/${params.id}`);
                    }}
                    disabled={loading}
                  >
                    {loading ? (
                      <CircularProgress size={20} />
                    ) : (
                      <Typography sx={{ fontSize: "16px" }}>
                        Take a Hearing Test
                      </Typography>
                    )}
                  </Button>
                )}
              </Box>

              <Button
                onClick={onclickButton}
                variant="contained"
                sx={{
                  backgroundColor: loading
                    ? "#BDBDBD"
                    : patient.frequency
                    ? "#424242"
                    : "#BDBDBD",
                  color: "white",
                  fontWeight: "500",
                  textTransform: "none",
                  padding: "8px 44px",
                }}
                disabled={loading || !patient.frequency}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <Typography sx={{ fontSize: "16px" }}>
                    Create Therapy
                  </Typography>
                )}
              </Button>
            </Box>
          </Box>

          {/* Divider */}
          <Divider />

          {/* Main Content */}
          <Grid container alignItems="stretch">
            {/* Left Section */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                height: "80%",
                borderRight: "1px solid #DEDEDE",
              }}
            >
              {/* Circular Charts Area */}
              <Box
                sx={{
                  width: "100%",
                  height: "240px",
                  borderBottom: "1px solid #DEDEDE",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {/* Today's Usage Chart */}
                <Box
                  sx={{
                    flex: 1,
                    borderRight: "1px solid #DEDEDE",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      backgroundColor: "#F5F5F5",
                      border: "1px solid #DBDBDB",
                      borderRadius: "3px",
                      px: 1,
                      py: 0.5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#424242",
                      }}
                    >
                      {todayDate}
                    </Typography>
                  </Box>
                  <UsageChart
                    value={todayUsage.value}
                    maxValue={todayUsage.maxValue}
                    displayValue={todayUsage.displayValue}
                    title="Today's Usage"
                  />{" "}
                </Box>

                {/* Weekly Usage Chart */}
                <Box
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <UsageChart
                    value={weeklyUsage.value}
                    maxValue={weeklyUsage.maxValue}
                    displayValue={weeklyUsage.displayValue}
                    title="Weekly Usage"
                  />
                </Box>
              </Box>
              <Grid2
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  borderBottom: "1px solid #DEDEDE",
                  padding: "10px",
                }}
              >
                <Typography
                  sx={{
                    justifyContent: "center",
                    fontSize: "20px",
                    alignItems: "center",
                    mb: "5px",
                  }}
                >
                  Therapy
                </Typography>
              </Grid2>
              {/* Therapy List */}
              <Grid2
                sx={{
                  paddingTop: "8px",
                  display: "flex",
                  flexDirection: "column",
                  paddingRight: "20px",
                  paddingLeft: "20px",
                  maxHeight: "240px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  minHeight: "240px",

                  "&::-webkit-scrollbar": {
                    width: "10px",
                  },

                  "&::-webkit-scrollbar-thumb": {
                    background: "#DCDCDC",
                    borderRadius: "10px",
                    minHeight: "20px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: "#B33D3D",
                  },
                }}
              >
                {therapyUsage.length === 0 ? (
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#757575",
                      fontWeight: 500,
                      textAlign: "center",
                      justifyContent: "center",

                      fontSize: "22px",
                      flexGrow: 1, // Ensures it fills the parent
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    No therapy available
                  </Typography>
                ) : (
                  therapyUsage.map((therapy, index) => (
                    <Grid2
                      key={index}
                      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                    >
                      {/* Therapy Name */}
                      <Typography
                        variant="body2"
                        sx={{ color: "#424242", fontWeight: 500 }}
                      >
                        {therapy.name}
                      </Typography>

                      {/* Progress Bar */}
                      <Grid2
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <Tooltip title={`${therapy.usage} minutes used`} arrow>
                          <LinearProgress
                            variant="determinate"
                            value={(therapy.usage / therapy.maxUsage) * 100}
                            sx={{
                              flex: 1,
                              height: "8px",
                              borderRadius: "4px",
                              backgroundColor: "#F0F0F0",
                              "& .MuiLinearProgress-bar": {
                                backgroundColor: "#D34646",
                              },
                            }}
                          />
                        </Tooltip>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#757575",
                            fontWeight: 400,
                            paddingLeft: "24px",
                          }}
                        >
                          {therapy.maxUsage}m
                        </Typography>
                      </Grid2>
                    </Grid2>
                  ))
                )}
              </Grid2>
            </Grid>

            {/* Right Section */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              {/* Date Picker with Tabs */}
              <Grid2
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #DEDEDE",
                  padding: "10px",
                }}
              >
                {/* Date Picker Section */}
                <Grid2
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexGrow: 1,
                    justifyContent: "center",
                    pl: "120px",
                  }}
                >
                  <IconButton onClick={() => handleDateNavigation(-1)}>
                    <ArrowBackIos />
                  </IconButton>
                  <Typography variant="h6">
                    {getDateNavigatorLabel()}
                  </Typography>
                  <IconButton onClick={() => handleDateNavigation(1)}>
                    <ArrowForwardIos />
                  </IconButton>
                </Grid2>

                {/* Tabs Section */}
                <Grid2
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Tabs
                    value={isMonthly ? 1 : 0}
                    onChange={(event, newValue) => setIsMonthly(newValue === 1)}
                    textColor="primary"
                    sx={{
                      "& .MuiTabs-indicator": {
                        display: "none",
                      },
                    }}
                  >
                    <Tab
                      label="Weekly"
                      sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
                    />
                    <Tab
                      label="Monthly"
                      sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
                    />
                  </Tabs>
                </Grid2>
              </Grid2>

              {/* Bar Chart */}
              <Box sx={{ flex: 1, padding: "10px" }}>
                <CustomBarChart
                  data={
                    isMonthly ? generateMonthlyData() : generateWeeklyData()
                  }
                  highlightedIndex={
                    isMonthly ? selectedDate?.date() - 1 : selectedDate.day()
                  }
                  barSize={isMonthly ? 10 : 60}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid2>
      </Box>
    </>
  );
};

export default PatientDashboardUi;